// src/screens/AdminUsersScreen.jsx
import React, { useState, useEffect } from 'react';
import { useAuth } from './AuthContext.js';
import { useNavigate } from 'react-router-dom';

export default function AdminUsersScreen() {
  const { user, loading, logout } = useAuth();
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);




  const [form, setForm] = useState({
    email: '',
    password: '',
    role: 'user',
    store: ''
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    console.log("🧪 useEffect ran. user is:", user);
    if (!user || user.role !== 'admin') return;

    (async () => {
      try {
        const res = await fetch('/api/users', { credentials: 'include' });
        if (!res.ok) {
          console.error("❌ Server returned:", res.status);
          setUsers([]); // fallback to avoid crash
          return;
        }
        const data = await res.json();
        setUsers(data);
      } catch (err) {
        console.error("❌ Fetch error:", err);
        setUsers([]); // fallback
      }
    })();
  }, [user, success]);


  // ✅ EARLY RETURN *after* hooks
  if (loading) return <p>Loading…</p>;

  if (!user || user.role !== 'admin') {
    return <p className="p-4">❌ You’re not authorized to view this page.</p>;
  }

  const handleChange = (field) => (e) => {
    setForm(f => ({ ...f, [field]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    const res = await fetch('/api/users', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(form)
    });
    if (res.ok) {
      setSuccess(`User ${form.email} created!`);
      setForm({ email: '', password: '', role: 'user', store: '' });
    } else {
      const data = await res.json();
      setError(data.error || 'Failed to add user');
    }
  };

  const handleDelete = async (id) => {
    if (id === user?.id) {
      alert("⛔ You can't delete yourself while logged in.");
      return;
    }
    if (!window.confirm("Are you sure you want to delete this user?")) return;
    const res = await fetch(`/api/users/${id}`, {
      method: 'DELETE',
      credentials: 'include'
    });
    if (res.ok) {
      setUsers(users.filter(u => u.id !== id));
    } else {
      alert("Failed to delete user.");
    }
  };


  return (
    <div className="p-6 max-w-3xl mx-auto bg-white rounded shadow space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-bold">👤 Admin Panel</h2>
        <button
          onClick={logout}
          className="text-sm text-red-600 underline"
        >
          🔒 Logout
        </button>
      </div>

      {error && <div className="text-red-600">{error}</div>}
      {success && <div className="text-green-600">{success}</div>}

      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <input type="email" placeholder="Email" required value={form.email} onChange={handleChange('email')} className="border rounded px-2 py-1" />
          <input type="password" placeholder="Password" required value={form.password} onChange={handleChange('password')} className="border rounded px-2 py-1" />
          <select value={form.role} onChange={handleChange('role')} className="border rounded px-2 py-1">
            <option value="user">User</option>
            <option value="admin">Admin</option>
          </select>
          <input type="text" placeholder="Store" value={form.store} onChange={handleChange('store')} className="border rounded px-2 py-1" />
        </div>
        <button type="submit" className="bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700">
          ➕ Add User
        </button>
      </form>

      <hr />

      <h3 className="text-xl font-bold">Current Users</h3>
      <table className="w-full table-auto text-left border-collapse mt-2">
        <thead>
          <tr className="bg-gray-100">
            <th className="border px-2 py-1">Email</th>
            <th className="border px-2 py-1">Role</th>
            <th className="border px-2 py-1">Store</th>
            <th className="border px-2 py-1">Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map(u => (
            <tr key={u.id}>
              <td className="border px-2 py-1">{u.email}</td>
              <td className="border px-2 py-1">{u.role}</td>
              <td className="border px-2 py-1">{u.store}</td>
              <td className="border px-2 py-1">
                <button
                  onClick={() => handleDelete(u.id)}
                  className="text-red-500 underline hover:text-red-700 text-sm"
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <button
        className="mt-4 text-sm text-gray-500 underline"
        onClick={() => navigate("/")}
      >
        ← Back to Inventory
      </button>
    </div>
  );
}